import { CIError } from 'common/error/error_util';
import { DeviceInitializerPlugin } from '../ci-native-plugins/CIPlugins';

export class NativeDeviceInitializer {
    static async getDeviceSerialNumber(): Promise<string> {
        try {
            const { deviceUniqueId } = await DeviceInitializerPlugin.getDeviceUniqueId();

            return deviceUniqueId;
        } catch (error) {
            throw CIError.fromNativeError({
                code: error.code,
                message: error.message,
            });
        }
    }
}
